import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Appbar = _resolveComponent("Appbar")!
  const _component_NavSidebar = _resolveComponent("NavSidebar")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_banner = _resolveComponent("v-banner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_idle_warning = _resolveComponent("idle-warning")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (!_ctx.state.authRoute && _ctx.getCurrentRoute !== 'NoAccess')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Appbar, {
              onToggleNav: _ctx.toggleNav,
              onOpenNav: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.navDrawer = true)),
              pageTitle: this.$route.meta.pageTitle,
              userName: _ctx.userFullName()
            }, null, 8, ["onToggleNav", "pageTitle", "userName"]),
            _createVNode(_component_NavSidebar, {
              app: "",
              modelValue: _ctx.state.navDrawer,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.navDrawer) = $event)),
              navType: _ctx.xsBreakpoint
            }, null, 8, ["modelValue", "navType"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_app_bar, {
              density: "compact",
              color: "primary",
              fixed: "",
              elevation: "5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_app_bar_title, null, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Destination Pet Admin", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (_ctx.state.updateExists)
            ? (_openBlock(), _createBlock(_component_v_banner, {
                key: 0,
                sticky: true,
                lines: "one",
                color: "primary",
                class: "pr-6"
              }, {
                text: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" An update is available. ", -1)
                ]))]),
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: _ctx.refreshApp
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Update ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _cache[5] || (_cache[5] = _createElementVNode("div", { id: "alert-region" }, null, -1)),
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_idle_warning)
    ]),
    _: 1
  }))
}